/* eslint-disable */
import React, { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { Link } from "react-router-dom";

import useCollapse from "react-collapsed";
import {
  FaCashRegister,
  FaFileMedical,
  FaFileExcel,
  FaAngleDown,
  FaAngleUp,
  FaList,
  FaRegUser,
  FaClipboardCheck,
  FaPowerOff,
  FaRegEdit,
  FaRegTrashAlt,
} from "react-icons/fa";
import BASE_API_URL from "../../../api/api.js";
import apiInstance from "../../../Utils/api.js";
const Income = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance

  const scroll = {
    height: "550px",
    overflowY: "scroll",
  };
  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);
  const [relatedLists, setRelatedLists] = useState([]);
  const [isShow, setIsShow] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [showOri, setShowOri] = useState(true);
  const [showBranch, setShowBranch] = useState(false);
  const [branchLists, setBranchLists] = useState([]);
  const [branchFilterList, setBranchFilterList] = useState([]);
  const [showBranchFilter, setShowBranchFilter] = useState(false);
  const [JEOri, setJEOri] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [dateList, setDateList] = useState([]);
  const { getCollapseProps, getToggleProps } = useCollapse();

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };

  const [journalEntryLists, setJournalEntryLists] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);

  const showDialog = () => setOpen(true);
  const _export = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      console.log(_export.current.props.data);
      _export.current.props.data.map(function (element, index) {
        element.transferDate = element.transferDate
          ? element.transferDate.split("T")[0]
          : "";
        element.fromAccName = element.fromAccount.name;
        element.toAccName = element.toAccount.name;
      });
      _export.current.save();
    }
  };

  const handleDelete = (val) => {
    console.log(val, "delete id");
    const getDELETE = async () => {
      console.log("ehre==");

      const res = await api
        .delete("transfer-report/" + val)
        .then((response) => {
          Swal.fire({
            title: "Success",
            text: "Successfully Deleted!",
            icon: "success",
            confirmButtonText: "OK",
          });

          setJournalEntryLists(
            journalEntryLists.filter((item) => item._id !== val),
          );
        })

        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "CANCEL",
          });
        });
    };
    getDELETE();
  };
  const handleBranch = (id) => {
    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 4000,
    }).then(
      () => {},
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      },
    );
    console.log(id, "name");
    if (id == "HO") {
      setShowBranchFilter(false);
      setShowOri(true);
      setShowSearch(false);
    } else {
      setBranchFilterList(
        JEOri.filter(
          (el) => (el.relatedBranch ? el.relatedBranch._id : "") === id,
        ),
      );
      console.log(
        JEOri.filter(
          (el) => (el.relatedBranch ? el.relatedBranch._id : "") === id,
        ),
        "filter",
      );
      setShowBranchFilter(true);
      setShowOri(false);
      setShowSearch(false);
    }
  };
  const handleRelatedShow = (id, val) => {
    const getRelated = async () => {
      try {
        console.log(val);
        const res = await api.get("journal/related/" + val);

        console.log(res.data.data);
        setRelatedLists(res.data.data);
      } catch (err) {}
    };

    getRelated();

    if (isShow) {
      document.getElementById("toggle" + id).removeAttribute("hidden");
    } else {
      document.getElementById("toggle" + id).setAttribute("hidden", "hidden");
    }
    setIsShow(!isShow);
  };

  const handleDate = () => {
    const nDate = new Date(to);
    const endDate = nDate.setDate(nDate.getDate() + 1);

    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 4000,
    }).then(
      () => {},
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      },
    );

    setJournalEntryLists(
      JEOri.filter(
        (el) =>
          el.transferDate?.split("T")[0] >= from &&
          el.transferDate?.split("T")[0] <= to,
      ),
    );
    console.log(
      JEOri.filter(
        (el) =>
          el.transferDate?.split("T")[0] >= from &&
          el.transferDate?.split("T")[0] <= to,
      ),
      "date",
    );
    setShowDate(true);
    setShowOri(true);
    setShowSearch(false);
    setShowBranchFilter(false);
  };
  const search = () => {
    console.log(searchVal, "name");
    Swal.fire({
      title: "Loading ...",
      text: "Please Wait !",
      allowEscapeKey: false,
      allowOutsideClick: false,
      timer: 2000,
    }).then(
      () => {},
      (dismiss) => {
        if (dismiss === "timer") {
          console.log("closed by timer!!!!");
          Swal.fire({
            title: "Finished!",
            type: "success",
            timer: 4000,
            showConfirmButton: false,
          });
        }
      },
    );

    if (searchVal) {
      setJournalEntryLists(
        JEOri.filter(
          (el) =>
            (el.fromAccount ? el.fromAccount.name : "")
              .toLowerCase()
              .includes(searchVal.toLowerCase()) ||
            el.remark.toLowerCase().includes(searchVal.toLowerCase()),
        ),
      );
      console.log(
        JEOri.filter(
          (el) =>
            (el.fromAccount ? el.fromAccount.name : "")
              .toLowerCase()
              .includes(searchVal.toLowerCase()) ||
            el.remark.toLowerCase().includes(searchVal.toLowerCase()),
        ),
        "fil",
      );
      setShowSearch(true);
      setShowOri(true);
    } else {
      setShowSearch(false);
      setShowOri(true);
    }
  };
  useEffect(() => {
    const getIncomeLists = async () => {
      try {
        Swal.fire({
          title: "Loading ...",
          text: "Please Wait !",
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 4000,
        });

        const res = await api.get("transfer-report");

        // Date format Changing
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString();
        // console.log(formattedDate);
        // console.log(
        //   res.data.data.filter(
        //     (el) =>
        //       el.transferDate?.split("T")[0] === formattedDate?.split("T")[0]
        //   ),
        //   "all"
        // );
        // console.log();
        setJEOri(res.data.data);
        setJournalEntryLists(
          res.data.data.filter(
            (el) =>
              el.transferDate?.split("T")[0] === formattedDate?.split("T")[0],
          ),
        );
      } catch (err) {
        alert(err.message);
      }
    };
    const getBranches = async () => {
      try {
        const res = await api.get("branches");
        setBranchLists(res.data.list);
      } catch (err) {
        alert(err.message);
      }
    };
    getBranches();

    getIncomeLists();
  }, []);

  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active">
                      Transfer from Account Report
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className="row ">
                    <div className="form-group col-md-3">
                      <label>From</label>
                      <input
                        type="date"
                        name="from"
                        id="from"
                        className="form-control"
                        onChange={(e) => setFrom(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label>To</label>
                      <input
                        type="date"
                        name="to"
                        id="to"
                        className="form-control"
                        onChange={(e) => setTo(e.target.value)}
                      />
                    </div>
                    <div
                      className="form-group col-md-2"
                      style={{ marginTop: "2.5em" }}
                    >
                      <button
                        className="btn btn-primary form-control"
                        onClick={handleDate}
                      >
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div
                      className="col-5 form-group"
                      style={{ marginTop: "35px" }}
                    >
                      <input
                        type="search"
                        className="form-control rounded"
                        id="search_code"
                        placeholder="Search"
                        onChange={(e) => setSearchVal(e.target.value)}
                      />
                    </div>
                    <div className="col-2">
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        style={{ marginTop: "2.6em" }}
                        onClick={search}
                      >
                        Search
                      </button>
                    </div>
                    {/* <div className='col-md-4' style={{ marginTop: "2.9em" }}>
                      <div className='form-group'>
                        <select
                          name='currency'
                          id=''
                          className='form-control '
                          // onchange='convert(this.value)'
                          // placeholder='Filter By Branches'
                          onChange={(e) => handleBranch(e.target.value)}
                        >
                          <option hidden>Filter By Branches</option>
                          <option value='HO'>HO</option>

                          {branchLists.map((option) => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row justify-content-between">
                        <label className="">
                          {/* Income Transaction List */}
                          <span className="float-right">
                            {/* <button
                              type='button'
                              className='btn btn-sm btn-primary'
                              onClick={showDialog}
                            >
                              <i className='fas fa-plus'></i> Add
                            </button> */}
                            &nbsp;
                            {/* <a href="/income_type" className="btn btn-primary">
                            Income Type
                          </a> */}
                            <button
                              type="button"
                              className="btn btn-sm btn-success"
                              onClick={excelExport}
                            >
                              <FaFileExcel />
                              &nbsp; Export
                            </button>
                          </span>
                        </label>
                      </div>
                      <div className="row" id="trial_balance"></div>
                    </div>

                    <div className="card-body">
                      {/* Export data in Excel */}
                      <ExcelExport data={journalEntryLists} ref={_export}>
                        <ExcelExportColumn
                          field=""
                          title="No"
                          locked={true}
                          width={30}
                        />
                        <ExcelExportColumn
                          field="transferDate"
                          title="Transfer Date"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={200}
                        />

                        {/* <ExcelExportColumn
                          field='relatedBankAccount.name'
                          title='Bank Account'
                          headerCellOptions={{
                            textAlign: 'center'
                          }}
                          width={250}
                        /> */}

                        <ExcelExportColumn
                          field="fromAccName"
                          title="From Account"
                          headerCellOptions={{
                            textAlign: "center",
                          }}
                          width={250}
                        />

                        <ExcelExportColumn
                          field="toAccName"
                          title="To Account"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="transferAmount"
                          title="Transfer Amount"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="closingAmount"
                          title="Closing Amount"
                          width={150}
                        />
                        <ExcelExportColumn
                          field="remark"
                          title="Remark"
                          width={150}
                        />
                      </ExcelExport>
                      {/* Export Data in Excel end */}
                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="table-responsive text-black"
                            id="slimtest2"
                            style={scroll}
                          >
                            <table
                              className="table table-hover"
                              id="filter_date"
                            >
                              <thead className="sticky-top bg-light">
                                <tr>
                                  <th>#</th>
                                  <th>Date</th>
                                  <th>From Account</th>
                                  <th>To Account</th>
                                  <th>Transfer Amount</th>
                                  <th>Closing Amount</th>
                                  <th>Remark</th>

                                  {/* <th className='text-center'>Action</th> */}
                                </tr>
                              </thead>

                              {showOri &&
                                journalEntryLists
                                  .slice(0)
                                  .reverse()
                                  .map((journalEntry, i) => (
                                    <tbody className="">
                                      <tr>
                                        <td>{++i}</td>
                                        <td>
                                          {
                                            journalEntry.transferDate?.split(
                                              "T",
                                            )[0]
                                          }
                                        </td>
                                        <td>
                                          {journalEntry.fromAccount
                                            ? journalEntry.fromAccount.name
                                            : ""}
                                        </td>
                                        <td>
                                          {" "}
                                          {journalEntry.toAccount
                                            ? journalEntry.toAccount.name
                                            : ""}
                                        </td>
                                        <td>{journalEntry.transferAmount}</td>
                                        <td>{journalEntry?.closingAmount}</td>

                                        <td>{journalEntry.remark}</td>
                                      </tr>
                                    </tbody>
                                  ))}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Income;
